import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import ReturnOrdersList from '@shared/return_orders/ReturnOrdersList'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { returnOrderService } from '@services/admin/returnOrderService'

export default function AdminReturnOrdersList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { addJob } = useAdminNotification()
  const [importModalVisible, setImportModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['returns', 'returns.list']}
        actions={
          <>
            <Button icon={<UploadOutlined />} onClick={() => setImportModalVisible(true)}>
              {t('common.button.import')}
            </Button>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => navigate('/return_orders/new')}
            >
              {t('common.button.new')}
            </Button>
          </>
        }
      />
      <ReturnOrdersList
        service={returnOrderService}
        role="admin"
        showMerchantColumn={false}
        addJob={addJob}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}
      />
    </div>
  )
}
